export const selectStyle = {
    
    control: (provided, state) => ({
        ...provided,
         backgroundColor: 'white', 
         border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)',  
         boxShadow: state.isFocused ? 'none' : 'none', 
         '&:hover': {
           border: state.isFocused ? '1px solid var(--border-color)' : '1px solid var(--border-color)', // Apply blue border on hover if focused, otherwise regular border
         }, 
         minHeight: "unset", 
         width: '115px',
         height: '22px',
         cursor: 'pointer',    
         borderRadius: '5px',  
      }),
  

 

      dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--muted-text-color)',
        padding: '0px',
        "svg": {
            width: '14px',
            height: '14px',
        }
        }),
  

    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
        }),
        
        indicatorsContainer: (provided) => ({
        ...provided,
        }),

    option: (styles, { isDisabled, isFocused, isSelected }) => {
        let backgroundColor;
        let color;
        let cursor = isDisabled ? 'not-allowed' : 'pointer';

        if (isDisabled) {
            backgroundColor = undefined;
            color = 'var(--text-color)';
        } else if (isSelected) {
            backgroundColor = 'var(--secondary-background)';
            color = undefined;
        } else if (isFocused) {
            backgroundColor = 'var(--secondary-background)';
            color = "var(--text-color)";
        } else {
            backgroundColor = undefined;
            color = "var(--text-color)";
        }

        let activeBackgroundColor;
        if (!isDisabled) {
            if (isSelected) {
                activeBackgroundColor = '#fff';
            } else {
                activeBackgroundColor = '#fff';
            }
        }

        return {
            ...styles,
            fontSize: '13px',
            padding: '4px 8px', 
            fontWeight: '500',
            color: "var(--text-color)",
            backgroundColor: backgroundColor,
            cursor: cursor,
            overflow: 'hidden',
            ':active': {
                ...styles[':active'],
                backgroundColor: backgroundColor,
            },
        };
    },

    placeholder: (styles) => ({ ...styles, }), 
    singleValue: (styles ) => ({ ...styles, fontSize: '12px' }),

    input: (styles) => ({ 
        ...styles,  
        paddingTop: '0px',
        paddingBottom: '0px',
        margin: '0px',
        fontSize: '12px'
      }),
  
      valueContainer: (styles) => ({
        ...styles,
        padding: "0px",  
      }),
  
    menu: (provided, state) => ({
        ...provided,
        paddingTop: '0px',
        paddingBottom: '0px',
        zIndex: 999,
    }),
  


};

 